export enum StandardEmitEvent {
    CHANGE = 'change',
    SUBMIT = 'submit',
    ENTER = 'enter',
    INPUT = 'input',
    CLICK = 'click',
    RETURN = 'return',
    UPDATE = 'update'
  }
  